import { StyledScreenReaderSpan } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { configIcon } from './configIcon';
import StyledIcon from './styled-icon-element';

const { forwardRef } = React;

const propTypes = {
	icon: PropTypes.element.isRequired,
	color: PropTypes.string,
	dataTestId: PropTypes.string,
	height: PropTypes.string,
	srLabel: PropTypes.string,
	width: PropTypes.string,
	responsiveSize: PropTypes.oneOfType([
		PropTypes.oneOf(Object.keys(configIcon)),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(Object.keys(configIcon)) }),
				{},
			),
		),
	]),
};

const defaultProps = {
	color: `var(--color-global-black)`,
	dataTestId: null,
	height: undefined,
	srLabel: undefined,
	width: undefined,
	responsiveSize: 'xsmall',
};

const Icon = forwardRef(
	({ icon, color, dataTestId, height, srLabel, width, responsiveSize, ...rest }, ref) => (
		<StyledIcon
			icon={icon}
			color={color}
			data-testid={dataTestId}
			height={height}
			ref={ref}
			width={width}
			responsiveSize={responsiveSize}
			{...rest}
		>
			{srLabel && <StyledScreenReaderSpan>{srLabel}</StyledScreenReaderSpan>}
		</StyledIcon>
	),
);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
export { Icon, configIcon as iconElementConfig };
